import React, { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import api from "../services/api";
import "./ProfitLossPage.css";

const ProfitLossPage = () => {
  const { id: businessId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [summary, setSummary] = useState([]);
  const [allTransactions, setAllTransactions] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedTransactions, setSelectedTransactions] = useState([]);
  const [editCategory, setEditCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const [showEditPopup, setShowEditPopup] = useState(false);

  const queryParams = new URLSearchParams(location.search);
  const startDate = queryParams.get("start_date");
  const endDate = queryParams.get("end_date");
  const accountId = queryParams.get("account_id");

  //const [businessName, setBusinessName] = useState("");


  useEffect(() => {
    const fetchSummary = async () => {
      try {
        const res = await api.get(`/plaid/transactions/${businessId}/category-summary`, {
          params: {
            start_date: startDate,
            end_date: endDate,
            account_id: accountId || undefined,
          },
        });
        //setBusinessName(res.data.businessName);
        setSummary(res.data.summary);
        setAllTransactions(res.data.transactions);
      } catch (err) {
        console.error("Error fetching summary:", err);
        alert("Could not load profit/loss summary.");
      }
    };

    const fetchCategories = async () => {
      try {
        const res = await api.get("/categories", {
          params: { business_id: businessId },
        });
        setCategories(res.data);
      } catch (err) {
        console.error("Error fetching categories", err);
      }
    };

    fetchSummary();
    fetchCategories();
  }, [businessId, startDate, endDate, accountId]);

  const handleSelectTransaction = (id) => {
    setSelectedTransactions((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleEditSelected = async () => {
    try {
      await api.put("/transactions/update-categories", {
        transactionIds: selectedTransactions,
        category: editCategory,
        business_id: businessId,
      });

      alert("Updated!");
      setShowEditPopup(false);
      setSelectedTransactions([]);
      setEditCategory("");

      const res = await api.get(`/plaid/transactions/${businessId}/category-summary`, {
        params: {
          start_date: startDate,
          end_date: endDate,
          account_id: accountId || undefined,
        },
      });

      setSummary(res.data.summary);
      setAllTransactions(res.data.transactions);
    } catch (err) {
      console.error("Failed to update categories", err);
      alert("Failed to update categories.");
    }
  };

  const formatCategory = (cat) =>
    cat
      ? cat
          .toLowerCase()
          .replace(/_/g, " ")
          .replace(/\b\w/g, (c) => c.toUpperCase())
      : "";
  

      const handleDownloadPDF = async () => {
        try {
          const res = await api.post(
            "/print-profit-loss",
            {
              businessId,
              start_date: startDate,
              end_date: endDate,
              account_id: accountId || null,
            },
            { responseType: "blob" } // Ensure binary response
          );
      
          const blob = new Blob([res.data], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);
      
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "profit_loss_report.pdf");
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        } catch (err) {
          console.error("Failed to download PDF:", err);
          alert("Could not download the PDF.");
        }
      };
      
      

  return (
    <div className="profit-loss">
    <div className="mt-4">
   

      <h3>Profit/Loss Summary</h3>
      <p>
        From <strong>{startDate}</strong> to <strong>{endDate}</strong>
        {accountId && <> (Filtered by Account)</>}
      </p>

      {!selectedCategory ? (
        <>
          <table className="table-profit table-bordered">
            <thead>
              <tr>
                <th>Category</th>
                <th className="text-end">Total</th>
              </tr>
            </thead>
            <tbody>
              {(() => {
                const income = summary.filter((row) => row.type === "income");
                const expense = summary.filter((row) => row.type === "expense");

                //const totalIncome = income.reduce((sum, row) => sum + row.total, 0);
                //const totalExpense = expense.reduce((sum, row) => sum + row.total, 0);

                const totalIncome = income.reduce((sum, row) => sum + parseFloat(row.total || 0), 0);
                const totalExpense = expense.reduce((sum, row) => sum + parseFloat(row.total || 0), 0);

                const netProfit = Math.abs(totalIncome) - totalExpense;



                return (
                  <>
                    {/* Gross Income Group */}
                    {income.length > 0 && (
                      <>
                        
                        {income.map((row, idx) => (
                          <tr
                            key={`inc-${idx}`}
                            style={{ cursor: "pointer" }}
                            onClick={() => setSelectedCategory(row.category || null)}
                          >
                            <td>{row.category || "Uncategorized"}</td>
                            <td className="text-end">
                              {Math.abs(row.total).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD"
                              })}
                            </td>

                          </tr>
                          
                        ))}
                        <tr className="table-success">
                          <td><strong>Gross Income</strong></td>
                          <td className="text-end">
                          <strong>{Math.abs(totalIncome).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD"
                          })}</strong>
                        </td>

                        </tr>
                      </>
                    )}

                    {/* Total Expense Group */}
                    {expense.length > 0 && (
                      <>
                        
                        {expense.map((row, idx) => (
                          <tr
                            key={`exp-${idx}`}
                            style={{ cursor: "pointer" }}
                            onClick={() => setSelectedCategory(row.category || null)}
                          >
                          <td>{formatCategory(row.category || "Uncategorized")}</td>

                            
                            <td className="text-end" style={{ color: row.total < 0 ? "var(--brand)" : "var(--brand-ghost)" }}>
                              {Math.abs(row.total).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD"
                              })}
                            </td>
                          </tr>
                        ))}
                        <tr className="table-expense">
                          <td><strong>Total Expense</strong></td>
                          <td className="text-end">
                            <strong>{Math.abs(totalExpense).toLocaleString("en-US", {
                              style: "currency",
                              currency: "USD"
                            })}</strong>
                          </td>
                        </tr>
                        <tr className="table-profit-row">
                          <td><strong>Profit / Loss</strong></td>
                          <td className="text-end">
                            <strong>{netProfit.toLocaleString("en-US", {
                              style: "currency",
                              currency: "USD"
                            })}</strong>
                          </td>
                        </tr>

                      </>
                    )}
                  </>
                );
              })()}
            </tbody>
          </table>

          <button className="back-btn-profit btn-secondary" onClick={() => navigate(-1)}>
            Back
          </button>
          <button
            className="save-pdf-btn btn-info ms-2"
            onClick={handleDownloadPDF}
          >
            Save PDF
          </button>

        </>
      ) : (
        <>
          <h5>Transactions under: {formatCategory(selectedCategory)}</h5>

          <div style={{ marginBottom: "10px" }}>
            <button
              className="edit-profit-btn btn-primary btn-sm"
              onClick={() => setShowEditPopup(true)}
              disabled={selectedTransactions.length === 0}
            >
              Edit Category
            </button>{" "}
            <button className="back-btn-profit btn-secondary btn-sm" onClick={() => setSelectedCategory(null)}>
              Back to Summary
            </button>
          </div>

          {showEditPopup && (
            <>
              <div className="overlay" onClick={() => setShowEditPopup(false)}></div>
              <div className="popup" style={{ display: "flex" }}>
                <select
                  value={editCategory}
                  onChange={(e) => setEditCategory(e.target.value)}
                  className="form-control"
                >
                  <option value="">Select Category</option>
                  {categories.map((cat) => (
                    <option key={cat.id} value={cat.name}>
                      {formatCategory(cat.name)}
                    </option>
                  ))}
                </select>
                <div className="pop-buttons">
                <button onClick={handleEditSelected} className="btn btn-success">Submit</button>
                <button onClick={() => setShowEditPopup(false)} className="btn btn-secondary">Cancel</button>
                </div>
              </div>
            </>
          )}

          <table className="table-individual">
            <thead>
              <tr>
                <th className="txn-checkbox"></th>
                <th className="profit-date">Date</th>
                <th className="profit-description">Description</th>
                <th className="text-end-header">Amount</th>
                <th className="account-individual">Account</th>
              </tr>
            </thead>
            <tbody>
              {allTransactions
                .filter((txn) => txn.category === selectedCategory || (!txn.category && selectedCategory === null))
                .map((txn) => (
                  <tr
                      key={txn.id}
                      className={`profit-row-mobile ${selectedTransactions.includes(txn.id) ? "selected-row" : ""}`}
                      onClick={() => {
                        if (window.innerWidth <= 768) handleSelectTransaction(txn.id); // only on mobile
                      }}
                    >
                    <td className="txn-checkbox">
                      <input
                        type="checkbox"
                        checked={selectedTransactions.includes(txn.id)}
                        onChange={() => handleSelectTransaction(txn.id)}
                      />
                    </td>
                    <td className="profit-data-date">{new Date(txn.date).toLocaleDateString()}</td>
                    <td className="profit-data-description" title={txn.name}>
                    {txn.name.length > 40 ? txn.name.slice(0, 40) + "..." : txn.name}
                  </td>
                    <td className="profit-text-end" style={{ color: txn.amount < 0 ? "var(--brand)" : "var(--brand-ghost)", fontWeight: "bold" }}>
                      {Math.abs(txn.amount).toLocaleString("en-US", {
                        style: "currency",
                        currency: txn.currency_code || "USD"
                      })}
                    </td>
                    <td className="account-individual">
                      {txn.account_name || ""} {txn.mask || ""}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </>
      )}
    </div>
    </div>
  );
};

export default ProfitLossPage;





// import React, { useEffect, useState } from "react";
// import { useParams, useLocation, useNavigate } from "react-router-dom";
// import api from "../services/api";

// const ProfitLossPage = () => {
//   const { id: businessId } = useParams();
//   const location = useLocation();
//   const navigate = useNavigate();

//   const [summary, setSummary] = useState([]);
//   const [allTransactions, setAllTransactions] = useState([]);
//   const [selectedCategory, setSelectedCategory] = useState(null);
//   const [selectedTransactions, setSelectedTransactions] = useState([]);
//   const [editCategory, setEditCategory] = useState("");
//   const [categories, setCategories] = useState([]);
//   const [showEditPopup, setShowEditPopup] = useState(false);

//   const queryParams = new URLSearchParams(location.search);
//   const startDate = queryParams.get("start_date");
//   const endDate = queryParams.get("end_date");
//   const accountId = queryParams.get("account_id");

//   useEffect(() => {
//     const fetchSummary = async () => {
//       try {
//         const res = await api.get(`/api/plaid/transactions/${businessId}/category-summary`, {
//           params: {
//             start_date: startDate,
//             end_date: endDate,
//             account_id: accountId || undefined,
//           },
//         });
//         setSummary(res.data.summary);
//         setAllTransactions(res.data.transactions);
//       } catch (err) {
//         console.error("Error fetching summary:", err);
//         alert("Could not load profit/loss summary.");
//       }
//     };

//     const fetchCategories = async () => {
//       try {
//         const res = await api.get("/categories", {
//           params: { business_id: businessId },
//         });
//         setCategories(res.data);
//       } catch (err) {
//         console.error("Error fetching categories", err);
//       }
//     };

//     fetchSummary();
//     fetchCategories();
//   }, [businessId, startDate, endDate, accountId]);

//   const handleSelectTransaction = (id) => {
//     setSelectedTransactions((prev) =>
//       prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
//     );
//   };

//   // const handleEditSelected = async () => {
//   //   try {
//   //     await api.put("/transactions/update-categories", {
//   //       transactionIds: selectedTransactions,
//   //       category: editCategory,
//   //     });
//   //     alert("Updated!");
//   //     setShowEditPopup(false);
//   //     setSelectedTransactions([]);
//   //     setEditCategory("");

//   //     setSelectedCategory(null); // reset view
//   //   } catch (err) {
//   //     console.error("Failed to update categories", err);
//   //   }
//   // };

//   const handleEditSelected = async () => {
//     try {
//       await api.put("/transactions/update-categories", {
//         transactionIds: selectedTransactions,
//         category: editCategory,
//       });
  
//       alert("Updated!");
//       setShowEditPopup(false);
//       setSelectedTransactions([]);
//       setEditCategory("");
  
//       // 🔁 Refetch data while staying on same category view
//       const res = await api.get(`/api/plaid/transactions/${businessId}/category-summary`, {
//         params: {
//           start_date: startDate,
//           end_date: endDate,
//           account_id: accountId || undefined,
//         },
//       });
  
//       setSummary(res.data.summary);
//       setAllTransactions(res.data.transactions);
  
//     } catch (err) {
//       console.error("Failed to update categories", err);
//       alert("Failed to update categories.");
//     }
//   };
  

//   const formatCategory = (cat) =>
//     cat ? cat.toLowerCase().replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) : "";

//   return (
//     <div className="container mt-4">
//       <h3>Profit/Loss Summary</h3>
//       <p>
//         From <strong>{startDate}</strong> to <strong>{endDate}</strong>
//         {accountId && <> (Filtered by Account)</>}
//       </p>

//       {!selectedCategory ? (
//         <>
//           <table className="table table-bordered">
//             <thead>
//               <tr>
//                 <th>Category</th>
//                 <th className="text-end">Total</th>
//               </tr>
//             </thead>
//             <tbody>
//               {summary.map((row, idx) => (
//                 <tr key={idx} style={{ cursor: "pointer" }} onClick={() => setSelectedCategory(row.category || null)}>
//                   <td>{row.category || "Uncategorized"}</td>
//                   <td className="text-end" style={{ color: row.total < 0 ? "green" : "inherit" }}>
//                     {Math.abs(row.total).toLocaleString("en-US", {
//                       style: "currency",
//                       currency: "USD",
//                     })}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>

//           <button className="btn btn-secondary" onClick={() => navigate(-1)}>
//             Back
//           </button>
//         </>
//       ) : (
//         <>
//           <h5>Transactions under: {formatCategory(selectedCategory)}</h5>

//           <div style={{ marginBottom: "10px" }}>
//             <button
//               className="btn btn-primary btn-sm"
//               onClick={() => setShowEditPopup(true)}
//               disabled={selectedTransactions.length === 0}
//             >
//               Edit Category
//             </button>{" "}
//             <button className="btn btn-secondary btn-sm" onClick={() => setSelectedCategory(null)}>
//               Back to Summary
//             </button>
//           </div>

//           {showEditPopup && (
//             <>
//               <div className="overlay" onClick={() => setShowEditPopup(false)}></div>
//               <div className="popup" style={{ display: "flex" }}>
//                 <select
//                   value={editCategory}
//                   onChange={(e) => setEditCategory(e.target.value)}
//                   className="form-control"
//                 >
//                   <option value="">Select Category</option>
//                   {categories.map((cat) => (
//                     <option key={cat.id} value={cat.name}>
//                       {formatCategory(cat.name)}
//                     </option>
//                   ))}
//                 </select>
//                 <button onClick={handleEditSelected} className="btn btn-success">
//                   Submit
//                 </button>
//                 <button onClick={() => setShowEditPopup(false)} className="btn btn-secondary">
//                   Cancel
//                 </button>
//               </div>
//             </>
//           )}

//           <table className="table table-striped mt-3">
//             <thead>
//               <tr>
//                 <th></th>
//                 <th>Date</th>
//                 <th>Description</th>
//                 <th className="text-end">Amount</th>
//                 <th>Bank / Account</th>
//               </tr>
//             </thead>
//             <tbody>
//               {allTransactions
//                 .filter((txn) => txn.category === selectedCategory || (!txn.category && selectedCategory === null))
//                 .map((txn) => (
//                   <tr key={txn.id}>
//                     <td>
//                       <input
//                         type="checkbox"
//                         checked={selectedTransactions.includes(txn.id)}
//                         onChange={() => handleSelectTransaction(txn.id)}
//                       />
//                     </td>
//                     <td>{new Date(txn.date).toLocaleDateString()}</td>
//                     <td>{txn.name}</td>
//                     <td className="text-end" style={{ color: txn.amount < 0 ? "green" : "inherit", fontWeight: "bold" }}>
//                       {(Math.abs(txn.amount)).toLocaleString("en-US", {
//                         style: "currency",
//                         currency: txn.currency_code || "USD",
//                       })}
//                     </td>
//                     <td style={{ fontSize: "12px" }}>
//                       {txn.bank_name || "Unknown"} <br />
//                       {txn.account_name || ""} {txn.mask || ""}
//                     </td>
//                     <td>{txn.id}</td>
//                   </tr>
//                 ))}
//             </tbody>
//           </table>
//         </>
//       )}
//     </div>
//   );
// };

// export default ProfitLossPage;




// import React, { useEffect, useState } from "react";
// import { useParams, useLocation, useNavigate } from "react-router-dom";
// import api from "../services/api";

// const ProfitLossPage = () => {
//   const { id: businessId } = useParams();
//   const location = useLocation();
//   const navigate = useNavigate();

//   const [summary, setSummary] = useState([]);
//   const [allTransactions, setAllTransactions] = useState([]);
//   const [selectedCategory, setSelectedCategory] = useState(null);

//   const queryParams = new URLSearchParams(location.search);
//   const startDate = queryParams.get("start_date");
//   const endDate = queryParams.get("end_date");
//   const accountId = queryParams.get("account_id");

//   useEffect(() => {
//     const fetchSummary = async () => {
//       try {
//         const res = await api.get(`/api/plaid/transactions/${businessId}/category-summary`, {
//           params: {
//             start_date: startDate,
//             end_date: endDate,
//             account_id: accountId || undefined,
//           },
//         });

//         setSummary(res.data.summary || []);
//         setAllTransactions(res.data.transactions || []);
//       } catch (err) {
//         console.error("Error fetching summary:", err);
//         alert("Could not load profit/loss summary.");
//       }
//     };

//     fetchSummary();
//   }, [businessId, startDate, endDate, accountId]);

//   const filteredTransactions = selectedCategory
//     ? allTransactions.filter(t => t.category === selectedCategory)
//     : [];

//   return (
//     <div className="container mt-4">
//       <h3>Profit/Loss Summary</h3>
//       <p>
//         From <strong>{startDate}</strong> to <strong>{endDate}</strong>
//         {accountId && <> (Filtered by Account)</>}
//       </p>

//       {!selectedCategory ? (
//         <>
//           <table className="table table-bordered">
//             <thead>
//               <tr>
//                 <th>Category</th>
//                 <th className="text-end">Total</th>
//               </tr>
//             </thead>
//             <tbody>
//               {summary.map((row, idx) => (
//                 <tr
//                   key={idx}
//                   style={{ cursor: "pointer" }}
//                   onClick={() => setSelectedCategory(row.category)}
//                 >
//                   <td>{row.category || "Uncategorized"}</td>
//                   <td
//                     className="text-end"
//                     style={{ color: row.total < 0 ? "green" : "inherit" }}
//                   >
//                     {Math.abs(row.total).toLocaleString("en-US", {
//                       style: "currency",
//                       currency: "USD",
//                     })}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>

//           <button className="btn btn-secondary" onClick={() => navigate(-1)}>
//             Back
//           </button>
//         </>
//       ) : (
//         <>
//           <h5>Transactions for: {selectedCategory}</h5>
//           <table className="table table-striped">
//             <thead>
//               <tr>
//                 <th>Date</th>
//                 <th>Description</th>
//                 <th className="text-end">Amount</th>
//                 <th>Bank / Account</th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredTransactions.map((txn) => (
//                 <tr key={txn.id}>
//                   <td>{new Date(txn.date).toLocaleDateString()}</td>
//                   <td>{txn.name}</td>
//                   <td
//                     className="text-end"
//                     style={{ color: txn.amount < 0 ? "green" : "inherit" }}
//                   >
//                     {Math.abs(txn.amount).toLocaleString("en-US", {
//                       style: "currency",
//                       currency: txn.currency_code || "USD",
//                     })}
//                   </td>
//                   <td style={{ fontSize: "12px" }}>
//                     {txn.bank_name || "Unknown"}
//                     <br />
//                     {txn.account_name || ""} {txn.mask || ""}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>

//           <button className="btn btn-secondary btn-sm" onClick={() => setSelectedCategory(null)}>
//             Back to Summary
//           </button>
//         </>
//       )}
//     </div>
//   );
// };

// export default ProfitLossPage;





// import React, { useEffect, useState } from "react";
// import { useParams, useLocation, useNavigate } from "react-router-dom";
// import api from "../services/api";

// const ProfitLossPage = () => {
//   const { id: businessId } = useParams();
//   const location = useLocation();
//   const navigate = useNavigate();

//   const [summary, setSummary] = useState([]);

//   const queryParams = new URLSearchParams(location.search);
//   const startDate = queryParams.get("start_date");
//   const endDate = queryParams.get("end_date");
//   const accountId = queryParams.get("account_id");

//   useEffect(() => {
//     const fetchSummary = async () => {
//       try {
//         const res = await api.get(`/api/plaid/transactions/${businessId}/category-summary`, {
//           params: {
//             start_date: startDate,
//             end_date: endDate,
//             account_id: accountId || undefined,
//           },
//         });
//         setSummary(res.data);
//       } catch (err) {
//         console.error("Error fetching summary:", err);
//         alert("Could not load profit/loss summary.");
//       }
//     };

//     fetchSummary();
//   }, [businessId, startDate, endDate, accountId]);

//   return (
//     <div className="container mt-4">
//       <h3>Profit/Loss Summary</h3>
//       <p>
//         From <strong>{startDate}</strong> to <strong>{endDate}</strong>
//         {accountId && <> (Filtered by Account)</>}
//       </p>

//       <table className="table table-bordered">
//         <thead>
//           <tr>
//             <th>Category</th>
//             <th className="text-end">Total</th>
//           </tr>
//         </thead>
//         <tbody>
//           {summary.map((row, idx) => (
//             <tr key={idx}>
//               <td>{row.category || "Uncategorized"}</td>
//               <td className="text-end" style={{ color: row.total < 0 ? "green" : "inherit" }}>
//                 {Math.abs(row.total).toLocaleString("en-US", {
//                   style: "currency",
//                   currency: "USD",
//                 })}
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       <button className="btn btn-secondary" onClick={() => navigate(-1)}>
//         Back
//       </button>
//     </div>
//   );
// };

// export default ProfitLossPage;
